/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PayRouteImport } from './routes/pay'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TTokenRouteImport } from './routes/t/$token'

const PayRoute = PayRouteImport.update({
  id: '/pay',
  path: '/pay',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TTokenRoute = TTokenRouteImport.update({
  id: '/t/$token',
  path: '/t/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/pay': typeof PayRoute
  '/t/$token': typeof TTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/pay': typeof PayRoute
  '/t/$token': typeof TTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/pay': typeof PayRoute
  '/t/$token': typeof TTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/pay' | '/t/$token'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/pay' | '/t/$token'
  id: '__root__' | '/' | '/pay' | '/t/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PayRoute: typeof PayRoute
  TTokenRoute: typeof TTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/pay': {
      id: '/pay'
      path: '/pay'
      fullPath: '/pay'
      preLoaderRoute: typeof PayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$token': {
      id: '/t/$token'
      path: '/t/$token'
      fullPath: '/t/$token'
      preLoaderRoute: typeof TTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PayRoute: PayRoute,
  TTokenRoute: TTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
